<div class="addlocation-header">
  <div class="addlocaton-title">
    @if (showEditDialogTitl) {
      <span> {{ 'recordsSearch.editLocation' | translate }}</span>
    } @else {
      <span> {{ 'shared.addLocation' | translate }}</span>
    }
  </div>

  <button mat-button mat-dialog-close class="dialog__close">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon
      ><span class="close"> {{ 'shared.close' | translate }}</span>
    </button>
  </div>

  <div [formGroup]="globalSection" class="recordtitle-content">
    <table aria-hidden="true" class="admin-location">
      <thead class="export-labels">
        <tr>
          <th scope="col" >{{ 'shared.globalRegion' | translate| titlecase }}</th>
          <th scope="col" >{{ 'shared.division' | translate| titlecase }}</th>
          <th scope="col" >{{ 'shared.country' | translate| titlecase }}</th>
          <th scope="col">{{ 'shared.market' | translate| titlecase }}</th>
          <th scope="col" >{{ 'shared.submarket' | translate| titlecase }}</th>
          <th scope="col" >{{ 'shared.productType' | translate| titlecase }}</th>
        </tr>
      </thead>
      <tbody class="export-input">
        <tr>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select
                formControlName="globalRegionFC"
                id="globalRegionSelect"
                class="global-region"
                disableOptionCentering
                >
                @for (region of globalRegionList; track region) {
                  <mat-option [value]="region">
                    {{ region.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select formControlName="divisionFC" id="regionSelect" name="regionSelect" disableOptionCentering>
                @for (division of divisionList; track division) {
                  <mat-option [value]="division">
                    {{ division.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select formControlName="countryFC" id="countrySelect" name="countrySelect" disableOptionCentering>
                @for (country of countryList; track country) {
                  <mat-option [value]="country">
                    {{ country.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select formControlName="marketFC" id="marketSelect" name="marketSelect" disableOptionCentering>
                @for (market of marketList; track market) {
                  <mat-option [value]="market">
                    {{ market.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select formControlName="submarketFC" id="submarketSelect" disableOptionCentering>
                @for (submarket of subMarketList; track submarket) {
                  <mat-option [value]="submarket">
                    {{ submarket.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col">
            <mat-form-field appearance="outline">
              <mat-select formControlName="productTypeFC" id="productSelect" name="productSelect" disableOptionCentering>
                @for (product of productTypeList; track product) {
                  <mat-option [value]="product">
                    {{ product.value }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </th>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="advance-search">
    <button
      class="search-text txt-button"
      (click)="advancedSearch()"
      [disabled]="selectedSubMarket.key === 0"
      >
      {{ 'shared.advancedSearch' | translate }}
    </button>
  </div>
